<template>
  <div>
    <div class="kit__utils__heading">
      <h5>
        <span class="mr-3">Gestión de ventas</span>
      </h5>
    </div>
    <div class="card">
      <div class="card-body">
        <b-row>
          <div class="col">
            <h5 class="mb-4">
              <strong>Lista de Ventas</strong>
            </h5>
          </div>
          <b-col class="m-2" v-if="cashBoxCheck">
            <a-dropdown placement="bottomRight" style="position: absolute;right:1em;z-index:10;" :trigger="['click']" v-b-tooltip.hover title="Gestión de cajas">
              <button type="button" class="btn btn-light">
                <i class="fe fe-more-vertical" />
              </button>
              <a-menu slot="overlay">
                <a-menu-item class="px-0">
                  <a-button type="link" id="1" @click="modalChekout()" icon="reconciliation">Gestionar cajas</a-button>
                </a-menu-item>
                <a-menu-item class="px-0">
                  <a-button type="link" id="2" @click="openModalReport()" icon="file-excel">Reporte de cajas</a-button>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
        </b-col>
        </b-row>
        <b-form>
          <b-row>
            <b-col lg="5" xl="2">
              <b-form-group id="input-group-3" label="Código de factura:" label-for="input-3">
                <b-form-input id="input-3" v-model="consecutive" placeholder="Ingrese el código"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="5" xl="2">
              <b-form-group id="input-group-2" label="Identificación:" label-for="input-2">
                <b-form-input id="input-2" v-model="purchaseUser" placeholder="Ingrese el nip"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="5" xl="3">
              <b-form-group id="input-group-1" label="Vendedor:" label-for="input-1">
                <b-form-select v-model="seller" :options="roles"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="8" lg="5">
              <div class="d-flex flex-row">
                <div class="mr-2">
                  <label for="example-datepicker">Fecha inicial</label>
                  <b-form-datepicker id="example-datepicker" v-model="startDate" @input="search()" placeholder="Fecha inicial" class="mb-2" value-as-date></b-form-datepicker>
                </div>
                <div>
                  <label for="example-datepicker">Fecha final</label>
                  <b-form-datepicker id="example-datepicker2" v-model="endDate" @input="search()" placeholder="Fecha final" class="mb-2" value-as-date></b-form-datepicker>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-form>
        <b-row>
          <div class="col">
            <b-table v-if="(sales.rows).length !== 0" striped hover :fields="columns" :items="sales.rows" head-variant="light" responsive>
              <template #cell(total)="sale">
                {{ currencyFormat(sale.item.total) }}
              </template>
              <template #cell(userInvoice)="sale">
                {{ getFullName(sale.item.userInvoice) }}
              </template>
              <template #cell(createdAt)="sale">
                {{ showingDateFormat(sale.item.createdAt) }}
              </template>
              <template #cell(actions)="sale">
                <div class="text-center">
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>Ver información</span>
                    </template>
                    <button type="button" @click="() => openModal(sale.item)" class="btn btn-light mr-2 col-md-1 col-xl-auto">
                      <i class="fa fa-eye" />
                    </button>
                  </a-tooltip>
                  <a-tooltip placement="top" v-if="!sale.item.deletedAt">
                    <template slot="title">
                      <span> Eliminar venta</span>
                    </template>
                    <button type="button" v-on:click="deleteSale(sale.item)" class="btn btn-light mr-2 col-md-1 col-xl-auto" v-if="hasPermission([consts.permissions.DELETE_SALE])">
                      <i class="fa fa-times-circle text-red" />
                    </button>
                  </a-tooltip>
                  <span v-else class="badge badge-warning text-capitalize">Venta eliminada</span>
                </div>
              </template>
            </b-table>
            <empty-table v-else/>
          </div>
        </b-row>
        <b-row>
          <b-col>
            <b-pagination
              v-model="pagination.currentPage"
              :total-rows="pagination.rows"
              :per-page="pagination.perPage"
              @input="search()"
              aria-controls="my-table"
            ></b-pagination>
          </b-col>
          <b-col class="text-right">
            {{ pagination.rows }} resultados
          </b-col>
        </b-row>
      </div>
    </div>
    <b-modal id="editSale" size="lg" ref="modal" :title="'Editar factura #' + saleToEdit.id" hide-footer>
      <b-row class="justify-content-center">
        <b-col class="p-auto m-auto">
          <img :src="`${saleToEdit.userInvoice.pathAvatar}?tr=w-300`"
            @error="event => event.target.src = 'https://ik.imagekit.io/czqsnlwbh2e/users/avatars/user-placeholder_LxKtaNY341.webp'"
            width="200em" alt="..." class="img-thumbnail img-fluid" style="display: block; margin-left: auto; margin-right: auto;"><br/>
        </b-col>
      </b-row>
      <b-row class="justify-content-center" align= "center">
        <b-col sm="12" md="12">
          <b>Nombre:</b> {{ getFullName(saleToEdit.userInvoice) }}
        </b-col>
      </b-row>
      <b-row class="ml-2" align="center">
        <b-col sm="12" md="6">
          <b>Fecha:</b> {{ showingDateFormat(saleToEdit.createdAt) }}
        </b-col>
        <b-col sm="12" md="6">
          <b>Identificación:</b> {{ saleToEdit.userInvoice.cc }}
        </b-col>
      </b-row>
      <b-row class="ml-2" align="center">
        <b-col sm="12" md="6">
          <b>Saldo restante:</b> {{ saleToEdit.userInvoice.balance }}
        </b-col>
        <b-col sm="12" md="6" v-if="comboCheck">
          <b>{{ comboName }}s restantes:</b> {{ saleToEdit.userInvoice.combos }}
        </b-col>
      </b-row>
      <b-row class="ml-2"></b-row>
      <hr>
        <b-row>
          <div class="col">
            <b-table v-if="(productInvoices).length > 0" striped hover :fields="columnsProducts" :items="productInvoices" head-variant="light" responsive>
              <template #cell(unitCost)="invoice">
                {{ currencyFormat(invoice.item.unitCost) }}
              </template>
              <template #cell(total)="invoice">
                {{ currencyFormat(invoice.item.quantity * invoice.item.unitCost) }}
              </template>
              <template #cell(actions)="invoice">
                <div>
                  <a-tooltip placement="top" v-if="!invoice.item.deletedAt">
                    <template slot="title">
                      <span>Quitar Producto</span>
                    </template>
                  <button type="button" v-on:click="deleteProduct(invoice.item)" class="btn btn-light mr-2 col-md-1 col-xl-auto" v-if="hasPermission([consts.permissions.DELETE_SALE])">
                    <i class="fa fa-times-circle" />
                  </button>
                  </a-tooltip>
                  <span v-else class="badge badge-warning text-capitalize">Venta eliminada</span>
                </div>
              </template>
            </b-table>
            <empty-table v-else/>
          </div>
        </b-row>
      <b-row class="pull-right">
        <b-col>
          <b-form>
            <b-button @click="$bvModal.hide('editSale')" variant="light" size="sm" class="mr-2 mb-3 mt-3">Cancelar</b-button>
          </b-form>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="modal-checkout" no-enforce-focus ref="modal" title="Gestionar cajas" hide-footer size="lg">
      <div class="px-1 mt-2">
        <b-tabs content-class="mt-3">
          <b-tab title="Cajas cerradas" active>
            <div class="col px-2">
              <div class="px-0 col-10 col-md-4 mt-3 mb-2">
                <label for="input-cash-open">Nombre completo</label>
                <b-input id="input-cash-open" v-model="searchCashBoxClose" placeholder="Nombre del usuario"></b-input>
              </div>
              <b-table id="boxCash" v-if="dataCloseCashBox.length > 0" :per-page="5" :current-page="page" striped hover :fields="columnsCashBoxClose" :items="dataCloseCashBox" head-variant="light" responsive class="d-flex justify-content-center align-items-center">
                <template #cell(initialValue)="dataCloseCashBox">
                  <div class="d-flex justify-content-center align-items-center" style="margin-top: 1em;">
                    <b-form-group>
                   <b-input-group>
                     <div style="max-width: 110px; padding: 0px !important; margin: 0px !important;">
                       <money :id="dataCloseCashBox.item.idUserAccountable.toString()" style="max-width: 90px; padding: 3px !important;" v-model="dataCloseCashBox.item.initialValue" v-bind="money" class="form-input border border-1 money-focus py-1" />
                     </div>
                   </b-input-group>
                 </b-form-group>
                  </div>
                </template>
                <template #cell(isActive)>
                  <div class="badge badge-warning text-capitalize p-2 mt-1">Cerrada</div>
                </template>
                <template #cell(actions)="dataCloseCashBox">
                  <div>
                    <a-tooltip placement="top">
                      <template slot="title">
                        <span>Abrir caja</span>
                      </template>
                    <button type="button" v-on:click="openCashBox(dataCloseCashBox.item)" class="btn btn-light mr-2 col-md-1 col-xl-auto">
                      <i class="fa fa-unlock-alt" />
                    </button>
                    </a-tooltip>
                  </div>
                </template>
              </b-table>
              <empty-table v-else/>
            </div>
            <b-row>
          <b-col>
            <b-pagination
              v-model="page"
              :total-rows="dataCloseCashBox.length"
              :per-page="5"
              aria-controls="boxCash"
            ></b-pagination>
          </b-col>
          <b-col class="text-right">
            {{ dataCloseCashBox.length }} resultados
          </b-col>
            </b-row>
          </b-tab>
          <b-tab title="Cajas abiertas">
             <div class="col px-2">
                <div class="px-0 col-10 col-md-4 mt-3 mb-2">
                  <label for="input-cash-open">Nombre completo</label>
                  <b-input id="input-cash-open" v-model="searchCashBoxOpen" placeholder="Nombre del usuario"></b-input>
                </div>
                <b-table id="boxCash" v-if="dataOpenCashBox.length > 0" :per-page="5" :current-page="page" striped hover :fields="columnsCashBoxOpen" :items="dataOpenCashBox" head-variant="light" responsive>
                  <template #cell(value)="dataOpenCashBox">
                  <div class="d-flex justify-content-center align-items-center" style="margin-top: 1em;">
                    <b-form-group>
                      <b-input-group>
                        <div style="max-width: 110px; padding: 0px !important; margin: 0px !important;">
                          <money :id="dataOpenCashBox.item.idUserAccountable.toString()" style="max-width: 90px; padding: 0px !important; margin: 0px !important;" v-model="dataOpenCashBox.item.value" v-bind="money" class="disabled-input" />
                        </div>
                      </b-input-group>
                    </b-form-group>
                  </div>
                  </template>
                  <template #cell(isActive)>
                    <div class="badge badge-success text-capitalize p-2 mt-1">Abierta</div>
                  </template>
                  <template #cell(startDate)="dataOpenCashBox">
                    {{ showingDateFormat(dataOpenCashBox.item.startDate) }}
                  </template>
                  <template #cell(actions)="dataOpenCashBox">
                    <div class="d-flex justify-content-end">
                      <a-tooltip placement="top" class="mr-1">
                        <template slot="title">
                          <span>Cerrar caja</span>
                        </template>
                      <button type="button" v-on:click="updateCashBox(1,dataOpenCashBox.item)" class="btn btn-light mr-2 col-md-1 col-xl-auto">
                        <i class="fa fa-lock" />
                      </button>
                      </a-tooltip>
                       <a-tooltip placement="top" class="mr-1">
                        <template slot="title">
                          <span>{{ dataOpenCashBox.item.isPaused ? 'Reanudar caja' : 'Pausar caja' }}</span>
                        </template>
                      <button type="button" v-on:click="updateCashBox(2,dataOpenCashBox.item)" class="btn btn-light mr-2 col-md-1 col-xl-auto">
                        <i :class="dataOpenCashBox.item.isPaused ? 'fa fa-play-circle': 'fa fa-pause-circle-o'" />
                      </button>
                      </a-tooltip>
                    </div>
                  </template>
                </b-table>
                <empty-table v-else/>
              </div>
              <b-row>
                  <b-col>
                    <b-pagination
                      v-model="page"
                      :total-rows="dataOpenCashBox.length"
                      :per-page="5"
                      aria-controls="boxCash"
                    ></b-pagination>
                  </b-col>
                  <b-col class="text-right">
                    {{ dataOpenCashBox.length }} resultados
                  </b-col>
              </b-row>
          </b-tab>
        </b-tabs>
      </div>
      <span class="d-flex flex-row float-right mr-4 mb-3 mt-0 align-text-bottom">
        <b-button @click="$bvModal.hide('modal-checkout')" variant="light" size="sm">Cerrar</b-button>
      </span>
    </b-modal>
    <b-modal id="modal-report-cash-box" no-enforce-focus ref="modal" title="Reporte de cajas" hide-footer size="md">
      <div class="px-2 ml-2 mt-2">
        <div class="row mr-1" style="gap: 1em;">
          <b-col lg="5" class="px-0">
          <label for="cash-box-start">Fecha inicial</label>
          <b-form-datepicker
            id="cash-box-start"
            v-model="formReport.startDate"
            placeholder="Fecha inicial"
            value-as-date>
          </b-form-datepicker>
          </b-col>
          <b-col lg="5" class="px-0">
          <label for="cash-box-end">Fecha final</label>
          <b-form-datepicker
            id="cash-box-end"
            v-model="formReport.endDate"
            placeholder="Fecha final"
            value-as-date>
          </b-form-datepicker>
          </b-col>
          <b-col lg="5" class="px-0">
            <b-form-group id="cash-box-user" label="Vendedor:" label-for="cash-box-user">
              <b-form-select id="cash-box-user" v-model="formReport.user" :options="sellers"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col lg="4" class="px-0 mt-lg-2" v-show="areDatesCorrectly">
            <br class="d-none d-lg-block">
           <b-button variant="primary" @click="dowmnloadReportCashBox()" >Descargar</b-button>
          </b-col>
          <small class="p-2 text-black col-12 rounded mb-2" style="font-size: 1rem; background: #fffbe6;" v-show="!areDatesCorrectly">
            <i class="fa fa-info-circle mr-1 mt-0 text-warning" aria-hidden="true" /> El rango de fechas es incorrecto. <br />
          </small>
        </div>
      </div>
      <span class="d-flex flex-row float-right mr-4 mb-3 mt-0 align-text-bottom">
        <b-button @click="$bvModal.hide('modal-report-cash-box')" variant="light" size="sm">Cerrar</b-button>
      </span>
    </b-modal>
  </div>
</template>
<script>
import apiClient from '@/services/axios'
import { mapState } from 'vuex'
import Swal from 'sweetalert2'
import axios from 'axios'
import emptyTable from '@/components/custom/cardEmptyList'
import { consts, currencyFormat, currencyFormatPesos, hasPermission, showErrorMessage } from '@/services/utilities'
import store from 'store'
import moment from 'moment'
import apiClient2 from '@/services/axios/v2'
import { Money } from 'v-money'
import { ToastFire } from '@/services/utilities/swal'

export default {
  name: 'salesManagement',
  components: { emptyTable, Money },
  data() {
    return {
      sales: {
        count: 0,
        rows: [],
      },
      productInvoices: [],
      startDate: '',
      endDate: '',
      start: '',
      end: '',
      total: '',
      boughtCombos: '',
      consecutive: '',
      purchaseUser: '',
      seller: null,
      msgValueToChargeValidation: '',
      msgValueToChargeValidationCombos: '',
      chargeActiveButton: true,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '$',
        suffix: '',
        precision: 0,
        masked: false, /* doesn't work with directive */
      },
      saleToEdit: {
        id: '',
        idUser: '',
        total: '',
        previousValue: '',
        boughtCombos: '',
        previousBoughtCombos: '',
        userInvoice: {
          firstName: '',
          secondName: '',
          firstLastName: '',
          secondLastName: '',
          cc: '',
          balance: '',
          pathAvatar: '',
          combos: '',
        },
      },
      columns: [
        { key: 'consecutive', label: 'Código factura' },
        { key: 'userInvoice.cc', label: 'Identificación' },
        { key: 'userInvoice', label: 'Nombre y Apellido' },
        { key: 'Total', label: 'Valor' },
        { key: 'createdAt', label: 'Fecha' },
        { key: 'actions', label: 'Acciones' },
      ],
      columnsCashBoxClose: [
        { key: 'name', label: 'Nombre completo' },
        { key: 'initialValue', thClass: 'text-center', tdClass: 'p-0', label: 'Base' },
        { key: 'isActive', thClass: 'text-center', tdClass: 'text-center', label: 'Caja' },
        { key: 'actions', thClass: 'text-center', tdClass: 'text-center', label: 'Acciones' },
      ],
      columnsCashBoxOpen: [
        { key: 'name', label: 'Nombre completo' },
        { key: 'value', label: 'Base', thClass: 'text-center', tdClass: 'p-0' },
        { key: 'isActive', thClass: 'text-center', tdClass: 'text-center', label: 'Caja' },
        { key: 'startDate', thClass: 'text-center', tdClass: 'text-center', label: 'Fecha' },
        { key: 'actions', thClass: 'text-center', tdClass: 'text-center', label: 'Acciones' },
      ],
      columnsProducts: [
        { key: 'product', label: 'Producto' },
        { key: 'quantity', thClass: 'text-center', tdClass: 'text-center', label: 'Cantidad' },
        { key: 'unitCost', thClass: 'text-center', tdClass: 'text-center', label: 'Valor unidad' },
        { key: 'total', label: 'Total' },
        { key: 'actions', thClass: 'text-center', tdClass: 'text-center', label: 'Acciones' },
      ],
      roles: [
        { value: null, text: 'Seleccione un vendedor' },
      ],
      pagination: {
        rows: 0,
        perPage: 10,
        currentPage: 1,
      },
      typingTimer: '',
      accessToken: '',
      comboCheck: false,
      comboName: '',
      consts: consts,
      dataCloseCashBox: [],
      dataOpenCashBox: [],
      searchCashBoxOpen: '',
      filteredCashier: [],
      searchCashierTimer: '',
      searchCashBoxClose: '',
      page: 1,
      loadCashBox: {
        open: [],
        closed: [],
      },
      formReport: {
        startDate: '',
        endDate: '',
        user: null,
      },
      cashBoxCheck: false,
      sellers: [],
    }
  },
  computed: {
    ...mapState(['user']),
    currencyFormatBalance: function () {
      return currencyFormat()
    },
    areDatesCorrectly: function () {
      if (this.formReport.startDate <= this.formReport.endDate) {
        return true
      }
      return false
    },
  },
  beforeRouteEnter (to, from, next) {
    function getSales() {
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      const minDate = new Date(today)
      minDate.setMonth(minDate.getMonth() - 1)
      const start = moment(minDate).format('YYYY-MM-DD')
      const end = moment(today).format('YYYY-MM-DD')
      const sentParams = {
        start: start,
        end: end,
        perPage: 10,
        currentPage: 0,
      }
      return apiClient.get('/sales/management', { params: { sentParams: sentParams } })
    }
    function getRoles() {
      return apiClient.get('/roles')
    }
    function getCombos() {
      return apiClient2.get('/schoolParam/active')
    }
    axios.all([getSales(), getRoles(), getCombos()])
      .then(axios.spread(function (sales, roles, combos) {
        next((vm) => {
          vm.setDataSales(null, sales.data)
          vm.setDataCombos(null, combos.data.data)
          vm.setDataRoles(null, roles.data.results)
        })
      }))
      .catch(err => {
        next((vm) => {
          vm.setDataSales(err, [])
          vm.setDataCombos(err, [])
          vm.setDataRoles(err, [])
        })
      })
  },
  watch: {
    consecutive: function () {
      this.getBySearchFields()
    },
    'loadCashBox.open': function() {
      this.dataOpenCashBox = this.loadCashBox.open
    },
    'loadCashBox.closed': function() {
      this.dataCloseCashBox = this.loadCashBox.closed
    },
    purchaseUser: function () {
      this.getBySearchFields()
    },
    seller: function () {
      this.getBySearchFields()
    },
    searchCashBoxOpen: function () {
      clearTimeout(this.searchCashierTimer)
      this.searchCashierTimer = setTimeout(() => {
        const searchFullName = this.searchCashBoxOpen.length > 0 ? this.searchCashBoxOpen.split(' ').filter((item) => item.trim() !== '') : []
        this.filterCashBox(searchFullName, true)
      }, 500)
    },
    searchCashBoxClose: function () {
      clearTimeout(this.searchCashierTimer)
      this.searchCashierTimer = setTimeout(() => {
        const searchFullName = this.searchCashBoxClose.length > 0 ? this.searchCashBoxClose.split(' ').filter((item) => item.trim() !== '') : []
        this.filterCashBox(searchFullName, false)
      }, 500)
    },
  },
  methods: {
    hasPermission(permissions) {
      return hasPermission(permissions, this.user.permissions)
    },
    getFullName(user) {
      if (user !== false) {
        let fullName = user.firstName
        if (user.secondName !== null && user.secondName.length > 1) {
          fullName += ' ' + user.secondName
        }
        fullName += ' ' + user.firstLastName
        if (user.secondLastName !== null && user.secondLastName.length > 1) {
          fullName += ' ' + user.secondLastName
        }
        return fullName
      }
    },
    currencyFormat: function (money) {
      return currencyFormatPesos(money)
    },
    showingDateFormat: function (date) {
      return moment(date).format('YYYY-MM-DD h:mm:ss a')
    },
    deleteSale(sale) {
      Swal.fire({
        title: 'Confirmar eliminación de la venta',
        text: '¿Desea eliminar la venta ' + sale.consecutive + '?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminar',
        cancelButtonText: 'No.',
      }).then((result) => {
        if (result.isConfirmed) {
          apiClient.delete('/sales/management/' + sale.id).then(response => {
            const alertResponse = !this.comboCheck ? 'El saldo final es ' + currencyFormat(response.data.balance) : 'El saldo final es ' + currencyFormat(response.data.balance) + ' y el saldo de ' + this.comboName + 's es ' + currencyFormat(response.data.combos)
            Swal.fire('Venta eliminada con éxito', alertResponse, 'success')
            this.search()
          }).catch(e => {
            Swal.fire('Ooops ocurrio un error', showErrorMessage(e), 'error')
          })
        }
      })
    },
    deleteProduct(product) {
      Swal.fire({
        title: 'Confirmar eliminación del producto',
        text: '¿Desea eliminar la venta de ' + product.product + '?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminar',
        cancelButtonText: 'No.',
      }).then((result) => {
        if (result.isConfirmed && !product.isCombo) {
          apiClient.delete('/sales/management/product/' + product.id).then(response => {
            const alertResponse = !this.comboCheck ? 'El saldo final es ' + currencyFormat(response.data.balance) : 'El saldo final es ' + currencyFormat(response.data.balance) + ' y el saldo de ' + this.comboName + 's es ' + currencyFormat(response.data.combos)
            Swal.fire('Venta eliminada con éxito', alertResponse, 'success')
            this.$bvModal.hide('editSale')
            this.search()
          }).catch(e => {
            Swal.fire('Ooops ocurrio un error', showErrorMessage(e), 'error')
          })
        } else if (result.isConfirmed && product.isCombo) {
          apiClient.delete('/sales/management/combo/' + product.idInvoice).then(response => {
            const alertResponse = !this.comboCheck ? 'El saldo final es ' + currencyFormat(response.data.balance) : 'El saldo final es ' + currencyFormat(response.data.balance) + ' y el saldo de ' + this.comboName + 's es ' + currencyFormat(response.data.combos)
            Swal.fire('Venta eliminada con éxito', alertResponse, 'success')
            this.$bvModal.hide('editSale')
            this.search()
          }).catch(e => {
            Swal.fire('Ooops ocurrio un error', showErrorMessage(e), 'error')
          })
        }
      })
    },
    openModal(sale) {
      this.saleToEdit = sale
      this.total = sale.total
      this.boughtCombos = sale.boughtCombos
      this.saleToEdit.previousTotal = this.saleToEdit.total
      this.saleToEdit.previousBoughtCombos = this.saleToEdit.boughtCombos
      apiClient.get('/sales/management/' + sale.id).then(response => {
        this.productInvoices = response.data
        if (sale.boughtCombos > 0) {
          this.productInvoices.push({
            id: '-',
            idInvoice: sale.id,
            product: this.comboName,
            quantity: sale.boughtCombos,
            unitCost: '-',
            total: '-',
            isCombo: true,
          })
        }
      }).catch(error => {
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(error),
        })
      })
      this.$bvModal.show('editSale')
    },
    getBySearchFields() {
      clearTimeout(this.typingTimer)
      this.typingTimer = setTimeout(() => { this.search() }, 500)
    },
    setDataCombos (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        this.comboCheck = false
        this.comboName = 'Parametro no definido'
        for (const combo of data) {
          if (combo.key === consts.params.COMBO) {
            this.comboCheck = combo.active
            this.comboName = combo.value
            this.columns = [
              { key: 'consecutive', label: 'Código factura' },
              { key: 'userInvoice.cc', label: 'Identificación' },
              { key: 'userInvoice', label: 'Nombre y Apellido' },
              { key: 'total', label: 'Valor' },
              { key: 'boughtCombos', thClass: 'text-center', tdClass: 'text-center', label: this.comboName[0].toUpperCase() + this.comboName.slice(1).toLowerCase() + 's' },
              { key: 'createdAt', label: 'Fecha' },
              { key: 'actions', label: 'Acciones' },
            ]
          } else if (combo.key === consts.params.CASH_BOX) {
            this.cashBoxCheck = combo.active
          }
        }
      }
    },
    setDataSales (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        this.sales = data
        this.pagination.rows = this.sales.count
      }
    },
    setDataRoles (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        const roles = []
        // const neededRoles = [1, 2, 10, 11]
        apiClient.get('/sales/management/sellers').then(response => {
          response.data.forEach(i => roles.push({ value: i.id, text: this.getFullName(i) }))
        }).catch(err => {
          this.$notification.success({
            message: 'Ooops ocurrio un error',
            description: showErrorMessage(err),
          })
        })
        roles.unshift({ value: null, text: 'Seleccione un vendedor' })
        this.roles = roles
      }
    },
    search() { // Guarda un grado llamando a la API
      const sentParams = {
        consecutive: this.consecutive,
        purchaseUser: this.purchaseUser,
        seller: this.seller,
        start: this.startDate,
        end: this.endDate,
        perPage: this.pagination.perPage,
        currentPage: this.pagination.currentPage - 1,
      }
      apiClient.get('/sales/management', { params: { sentParams: sentParams } }).then(response => {
        this.sales = response.data
        this.pagination.rows = this.sales.count
      }).catch(error => {
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(error),
        })
      })
    },
    // Valida la recarga antes de enviar el patch
    validateEditSale() {
    },
    modalChekout () {
      this.getLoadCash()
      this.$bvModal.show('modal-checkout')
    },
    slugify: function(str) {
      var map = {
        '-': ' ',
        a: 'á|à|ã|â|ä|À|Á|Ã|Â|Ä',
        e: 'é|è|ê|ë|É|È|Ê|Ë',
        i: 'í|ì|î|ï|Í|Ì|Î|Ï',
        o: 'ó|ò|ô|õ|ö|Ó|Ò|Ô|Õ|Ö',
        u: 'ú|ù|û|ü|Ú|Ù|Û|Ü',
        c: 'ç|Ç',
      }
      for (var pattern in map) {
        str = str.replace(new RegExp(map[pattern], 'g'), pattern)
      }
      return str
    },
    openCashBox (item) {
      const box = {
        id: item.idUserAccountable,
        value: item.initialValue,
      }
      apiClient2.post('sales/cash-box', { box }).then((response) => {
        this.loadCashBox.closed = this.loadCashBox.closed.filter((element) => element.idUserAccountable !== response.data.data.idUserAccountable)
        this.loadCashBox.open.push({
          id: response.data.data.id,
          value: response.data.data.initialValue,
          name: item.name,
          idUserAccountable: response.data.data.idUserAccountable,
          isPaused: false,
          startDate: response.data.data.startDate,
        })
        this.dataCloseCashBox = this.loadCashBox.closed
        ToastFire('success', `Caja de ${item.name} habilitada`)
      }).catch((error) => {
        ToastFire('warning', showErrorMessage(error))
      })
    },
    updateCashBox (option, item) {
      let cashBox = {}
      switch (option) {
        case 1:
          cashBox = {
            id: item.id,
            isClosed: true,
          }
          break
        case 2:
          cashBox = {
            id: item.id,
            isPaused: !item.isPaused,
          }
          break
        default: return
      }
      apiClient2.patch(`sales/cash-box/${cashBox.id}`, cashBox).then((response) => {
        if (cashBox.isClosed) {
          this.dataOpenCashBox.map((element) => {
            if (element.id === cashBox.id) {
              this.loadCashBox.closed.push({
                name: element.name,
                idUserAccountable: element.idUserAccountable,
                initialValue: 0,
                isPaused: false,
              })
            }
          })
          this.loadCashBox.open = this.dataOpenCashBox.filter((element) => element.id !== item.id)
        } else if (cashBox.isPaused !== undefined) {
          this.dataOpenCashBox.map((element) => {
            if (element.id === item.id) {
              element.isPaused = !item.isPaused
            }
          })
        }
        ToastFire('success', response.data.message)
      }).catch((error) => {
        ToastFire('warning', showErrorMessage(error))
      })
    },
    filterCashBox(searchFullName, isOpen) {
      searchFullName = searchFullName.length > 0 ? searchFullName.map((item) => this.slugify(item.trim().toLowerCase())) : []
      if (isOpen) {
        this.dataOpenCashBox = this.loadCashBox.open.filter((item) => {
          let fullName = item.name.split(' ')
          fullName = fullName.length > 0 ? fullName.map((item) => this.slugify(item.trim().toLowerCase())) : []
          let count = 0
          searchFullName.map((name) => {
            fullName.map((item) => {
              if (item.includes(name)) {
                count++
              }
            })
          })
          if (count >= searchFullName.length) {
            return item
          }
        })
      } else {
        this.dataCloseCashBox = this.loadCashBox.closed.filter((item) => {
          let fullName = item.name.split(' ')
          fullName = fullName.length > 0 ? fullName.map((item) => this.slugify(item.trim().toLowerCase())) : []
          let count = 0
          searchFullName.map((name) => {
            fullName.map((item) => {
              if (item.includes(name)) {
                count++
              }
            })
          })
          if (count >= searchFullName.length) {
            return item
          }
        })
      }
    },
    getLoadCash() {
      apiClient2.get('sales/cash-box').then((response) => {
        this.loadCashBox = response.data.data
        this.dataOpenCashBox = this.loadCashBox.open
        this.dataCloseCashBox = this.loadCashBox.closed
      }).catch((error) => {
        ToastFire('warning', showErrorMessage(error))
      })
    },
    openModalReport () {
      this.sellers = []
      apiClient.get('/sales/management/sellers', { params: { sentParams: [2, 10, 11] } }).then(response => {
        response.data.forEach(i => this.sellers.push({ value: i.id, text: this.getFullName(i) }))
        this.sellers.unshift({ value: null, text: 'Seleccione un vendedor' })
        this.$bvModal.show('modal-report-cash-box')
      }).catch(err => {
        console.log('error', err)
        this.$notification.success({
          message: 'Ooops ocurrio un error',
          description: showErrorMessage(err),
        })
      })
    },
    dowmnloadReportCashBox() {
      const accessToken = store.get('accessToken')
      const endNameReport = moment().format('YYYY-MM-DD')
      const headers = {
        Authorization: `Bearer ${accessToken}`,
        AccessToken: accessToken,
      }
      axios({
        url: process.env.VUE_APP_API_URL_V2 + '/sales/cash-box/report',
        method: 'GET',
        params: {
          startDate: moment(this.formReport.startDate).format('YYYY-MM-DD'),
          endDate: moment(this.formReport.endDate).format('YYYY-MM-DD'),
          ...(this.formReport.user && { idUser: this.formReport.user }),
        },
        responseType: 'blob',
        headers: headers,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Reporte_de_cajas_${endNameReport}.xlsx`)
        document.body.appendChild(link)
        link.click()
      })
    },
  },
  created() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    const minDate = new Date(today)
    minDate.setMonth(minDate.getMonth() - 1)
    this.startDate = minDate
    this.endDate = today
    this.formReport.startDate = minDate
    this.formReport.endDate = today
    this.accessToken = store.get('accessToken')
  },
}
</script>
<style>
.disabled-input {
  pointer-events: none;
  background: transparent;
  border: none;
  border-radius: 3px;
}
.money-focus:focus {
  border: 1px solid #80bdff !important;
  height: 2em;
}
</style>
